export default __webpack_public_path__ + "static/media/2.20b1aba3.jpg";